@if (searchSuggestions() && searchSuggestions().length > 0) {
	<div class="ai-search-suggestions-container">
		<div class="title-wrapper">
			<mat-icon svgIcon="smart-stars"></mat-icon>
			<h3>{{ 'google_search_suggestions' | translate }}</h3>
		</div>

		<p>{{ 'google_search_suggestions_description' | translate }}</p>

		<div class="suggestions-chips-wrapper nice-scroll">
			<div class="suggestions-chips">
				@for (suggestion of searchSuggestions(); track suggestion.url) {
					<mat-chip
						class="suggestion-chip"
						(click)="openSuggestionInNewTab(suggestion.url)"
						[attr.aria-label]="suggestion.title"
					>
						{{ suggestion.title }}
						<mat-icon matChipTrailingIcon class="external-link-icon"
							>open_in_new</mat-icon
						>
					</mat-chip>
				}
			</div>
		</div>
	</div>
}
